module.exports = __webpack_public_path__ + "img/home_soraco.b57543a0.jpg";